import {
  ADD_CLIENT,
  API_CLIENTE,
  ADD_BENEFICIARY,
  REMOVE_BENEFICIARY,
  UPDATE_CLIENT,
  ADD_WORK_DATA,
  ADD_HEALTH_STATEMENT,
  ADD_ANSWERS,
  OPEN_MODAL,
  MODAL_STEPS,
  MODAL_ERRORS,
  MODAL_ASIDE,
  ERROR_TEXT,
  STEP_POSITION,
  DATA_MODAL,
  GENERATE_QUOTE,
  LOADING,
  ALERT,
  RESET,
  STATEALERT,
  ADD_CONTRACTOR, 
  ADD_INSURED, 
  ADD_LEGAL_REPRESENTATIVE,
  ADD_INSURED_WORK_DATA,
  ADD_CONTRACTOR_WORK_DATA,
  ADD_ACCUMULATED,
  ADD_SUPPORT
} from "./actions";

const initialState = {
  policy: {
    client: {},
    workData: {},
    beneficiary: [],
    healthStatement: [],
    answers: {},
    openModal: false,
    stepPosition: 1,
    modalSteps: false,
    modalError: false,
    modalAside: false,
    errortext: "default",
    apiCliente: {},
    dataModal: {
      success: false,
      message: "",
      btnText: "Cerrar",
      actionGenerate: false,
      errorCreate: false,
      errorUpdate: false,
    },
    generateQuote: false,
    loading: false,
    alert: {},
    stateAlert: false,
  },
};

const simulateReducer = (state = initialState, action) => {
  const {
    type,
    client,
    apiCliente,
    beneficiary,
    idBeneficiary,
    otherDataClient,
    workData,
    healthStatement,
    answers,
    openModal,
    modalSteps,
    modalError,
    modalAside,
    errortext,
    stepPosition,
    dataModal,
    generateQuote,
    loading,
    alert,
    stateAlert,
    insured,
    contractor,
    legal_representative,
    insuredWorkData,
    contractorWorkData,
    accumulated,
    support
  } = action;

  switch (type) {
    case ADD_CLIENT:
      return { ...state, policy: { ...state.policy, client } };
    case API_CLIENTE:
      return { ...state, policy: { ...state.policy, apiCliente } };
    case UPDATE_CLIENT:
      const updateClient = {
        ...state.policy.client.datosCliente,
        ...otherDataClient,
      };
      return {
        ...state,
        policy: {
          ...state.policy,
          client: { ...state.policy.client, datosCliente: updateClient },
        },
      };
    case ADD_BENEFICIARY:
      return { ...state, policy: { ...state.policy, beneficiary } };
    case REMOVE_BENEFICIARY:
      const updateBeneficiary = state.policy.beneficiary.filter(
        (item) => item.idBeneficiary !== idBeneficiary
      );
      return {
        ...state,
        policy: { ...state.policy, beneficiary: updateBeneficiary },
      };
    case ADD_WORK_DATA:
      return { ...state, policy: { ...state.policy, workData } };
    case ADD_HEALTH_STATEMENT:
      return { ...state, policy: { ...state.policy, healthStatement } };
    case ADD_ANSWERS:
      const newAnswers = { ...state.policy.answers, ...answers };
      return { ...state, policy: { ...state.policy, answers: newAnswers } };
    case OPEN_MODAL:
      return { ...state, policy: { ...state.policy, openModal } };
    case MODAL_STEPS:
      return { ...state, policy: { ...state.policy, modalSteps } };
    case MODAL_ERRORS:
      return { ...state, policy: { ...state.policy, modalError } };
    case MODAL_ASIDE:
      return { ...state, policy: { ...state.policy, modalAside}}
    case ERROR_TEXT:
      return { ...state, policy: { ...state.policy, errortext } };
    // case DATAOPENALERT:
    //   return { ...state, policy: { ...state.policy, dataOpenAlert}}
    case STEP_POSITION:
      return { ...state, policy: { ...state.policy, stepPosition } };
    case DATA_MODAL:
      return { ...state, policy: { ...state.policy, dataModal } };
    case GENERATE_QUOTE:
      return { ...state, policy: { ...state.policy, generateQuote } };
    case LOADING:
      return { ...state, policy: { ...state.policy, loading } };
    case ALERT:
      return { ...state, policy: { ...state.policy, alert } };
    case ADD_INSURED:
    return { ...state, policy: {
      ...state.policy,
      client: { ...state.policy.client, datosAsegurado: insured },
    }, };
    case ADD_CONTRACTOR:
      return { ...state, policy: {
        ...state.policy,
        client: { ...state.policy.client, datosJuridico: contractor },
      }, };
    case ADD_LEGAL_REPRESENTATIVE:
      return { ...state, policy: {
        ...state.policy,
        client: { ...state.policy.client, datosRepLegal: legal_representative },
      }, };
    case ADD_INSURED_WORK_DATA:
      const updateInsured = {
        ...state.policy.client.datosAsegurado,
        informacionLaboral: insuredWorkData
      };
      return { ...state, policy: {
        ...state.policy,
        client: { ...state.policy.client, datosAsegurado: updateInsured },
      }, };
    case ADD_CONTRACTOR_WORK_DATA:
      const updateContractor = {
        ...state.policy.client.datosJuridico,
        informacionLaboral: contractorWorkData
      };
      return { ...state, policy: {
        ...state.policy,
        client: { ...state.policy.client, datosJuridico: updateContractor },
      }, };
    case ADD_ACCUMULATED:
      return { ...state, policy: {
        ...state.policy,
        client: { ...state.policy.client, acumuladoOrigenesFondo: accumulated },
      }, };
    case ADD_SUPPORT:
      return { ...state, policy: {
        ...state.policy,
        client: { ...state.policy.client, sustento: support },
      }, };
    case STATEALERT:
      return { ...state, policy: { ...state.policy, stateAlert } };
    case RESET:
      return initialState;
    default:
      return state;
  }
};

export default simulateReducer;
